import AbstractService from 'services/AbstractService';


class SiteFacilitiesService extends AbstractService {
    constructor() {
        super();
        this.SITE_FACILITIES_CATALOG_FETCH_START = 'SITE_FACILITIES_CATALOG_FETCH_START';
        this.SITE_FACILITIES_CATALOG_FETCH_SUCCESS = 'SITE_FACILITIES_CATALOG_FETCH_SUCCESS';
        this.SITE_FACILITIES_CATALOG_FETCH_ERROR = 'SITE_FACILITIES_CATALOG_FETCH_ERROR';
        this.baseUrl = process.env.REACT_APP_BASE_URL;
    }

    getReducer() {
        return (state = this.getInitialState(), action) => {
            let newState = state;

            switch (action.type) {
                case this.SITE_FACILITIES_CATALOG_FETCH_SUCCESS:
                    newState = { siteFacilityCatalog: JSON.parse(action.response) };
                    break;

                default:  // stupid linting rule requires a default case
                    break;
            }
            return newState;
        };
    }

    getInitialState() {
        return {
            siteFacilityCatalog: []
        };
    }

    getStoreKey() {
        return 'sitesFacilities';
    }

    fetchSiteFacilitiesIfNeeded() {
        if (this._shouldFetchSiteFacilities(this.getMyState(this.getStore().getState()))) {
            this.dispatch({
                type: this.SITE_FACILITIES_CATALOG_FETCH_START
            });
        }
    }

    /**
     * Fetch if the sites & facilities have not already been loaded into the store
     * @param state - top level state (not just my sub-state)
     * @returns {boolean}
     */
    _shouldFetchSiteFacilities(myState) {
        const sites = myState.siteFacilityCatalog;
        let shouldFetch = false;
        if (sites.length === 0) {
            shouldFetch = true;
        }
        return shouldFetch;
    }
}

export default new SiteFacilitiesService();



// WEBPACK FOOTER //
// ./src/services/SiteFacilitiesService.js